import { ConfirmTipTicketRef } from 'features/payment/components/ConfirmTipTicket';
import React from 'react';
export const completedTicketModalRef = React.createRef<ConfirmTipTicketRef>();